import { routerMutex } from "@bebit/store";
import { DeviceCategory } from "@bebit/types";
import { computed, ComputedRef } from "vue";
import { useRouter, useRoute } from "vue-router";

export function useDeviceCategoryUrlParams() {
  const route = useRoute();
  const router = useRouter();
  const deviceCategoryFromUrl: ComputedRef<DeviceCategory | undefined> = computed(() => {
    const deviceCategory = (route.query.deviceCategory as string) || "";
    return isValidDeviceCategory(deviceCategory) ? (deviceCategory as DeviceCategory) : undefined;
  });

  function setDeviceCategoryToUrl(value: DeviceCategory) {
    routerMutex.runExclusive(async () => {
      await router.replace({ query: { ...route.query, deviceCategory: value } });
    });
  }

  return { deviceCategoryFromUrl, setDeviceCategoryToUrl };
}

function isValidDeviceCategory(deviceCategory: string | null): boolean {
  if (!deviceCategory) return false;
  return deviceCategory === DeviceCategory.PC || deviceCategory === DeviceCategory.SP;
}
